import { Injectable } from '@angular/core';
import { DynamicStyleSheetService, IDynamicStyleSheet } from '@captiveaire/dynamicstylesheet';
import { INamedFrameModel, IScheduleModel } from '@caslink/common-client';
import { ProxyService } from '@caslink/common-client/ng-app/proxy/ProxyService';
import * as _ from 'lodash';
import { IRtuScheduleModel, IScheduleSetpointModel, ISetpointModel } from '../models/models';

@Injectable({
    providedIn: 'root'
})
export class RtuStaticScheduleService {
    public static $name = 'rtuStaticScheduleService';

    private dynamicStyle: IDynamicStyleSheet;

    constructor(
        private dynamicStyleSheetService: DynamicStyleSheetService,
        private proxyService: ProxyService
    ) {
        this.dynamicStyle = this.dynamicStyleSheetService.getOrCreate('rtu-schedule-styles');
    }

    public addCssClassFromSetpoint(setpoint: IScheduleSetpointModel) {
        if (setpoint) {
            let selector = '.' + setpoint.name;
            let rule = 'background-color: ' + setpoint.color;
            this.dynamicStyle.addRule(selector, rule, 0);
        }
    }

    /** Based on the setpoints received from the server, add the name as a CSS selector to display the background color */
    public addCssClassesFromSetpoints(setpoints: IScheduleSetpointModel[]) {
        this.dynamicStyle.clearRules();

        let setpointNames = _.uniq(setpoints.map(r => r.name));

        setpointNames.forEach(name => {
            // get point color...
            let setpoint = _.find<IScheduleSetpointModel>(setpoints, r => r.name === name);
            this.addCssClassFromSetpoint(setpoint);
        });
    }

    public getRTUSchedule(hardwareItemId: number): angular.IPromise<IScheduleModel> {
        if (hardwareItemId <= 0) {
            return null;
        }

        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'getRtuSchedule',
            routeParams: {
                hardwareItemId: hardwareItemId
            }
        }).as<IScheduleModel>();
    }

    public overrideSchedule(
        locationId: number,
        locationAreaId: number,
        hardwareItemId: number,
        overrideMinutes: number,
        model: ISetpointModel
    ): angular.IPromise<void> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'addRtuScheduleOverride',
            data: model,
            routeParams: {
                locationId: locationId,
                locationAreaId: locationAreaId,
                hardwareItemId: hardwareItemId,
                overrideMinutes: overrideMinutes
            }
        }).asNoContent();
    }

    public updateSchedule(hardwareItemId: number, frames: INamedFrameModel[]) {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'updateRtuFrames',
            data: frames,
            routeParams: {
                hardwareItemId: hardwareItemId
            }
        }).as<IRtuScheduleModel>();
    }
}
